import { render, staticRenderFns } from "./WazdanFreespinsAddForm.vue?vue&type=template&id=4229bd57&"
import script from "./WazdanFreespinsAddForm.vue?vue&type=script&lang=js&"
export * from "./WazdanFreespinsAddForm.vue?vue&type=script&lang=js&"
import style0 from "./WazdanFreespinsAddForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports